import i18next, { InitOptions, Resource } from "i18next";
import { initReactI18next } from "react-i18next";
import resourcesToBackend from "i18next-resources-to-backend";

i18next
  .use(
    resourcesToBackend((language: string, namespace: string) => {
      return import(`./locales/${language}/${namespace}.json`);
    })
  )
  .use(initReactI18next)
  .init({
    lng: "el",
    fallbackLng: "el",
    supportedLngs: ["en", "el"],
    defaultNS: "common",
    fallbackNS: "common",
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
    debug: true,
  });

i18next.on("languageChanged", (lng: string) => {
  console.log("🌍 Language changed to:", lng);
});

i18next.on("loaded", (loaded: Resource) => {
  console.log("📦 Resources loaded:", loaded);
});

i18next.on("failedLoading", (lng: string, ns: string, msg: string) => {
  console.error("❌ Failed loading:", {
    language: lng,
    namespace: ns,
    message: msg,
  });
});

i18next.on(
  "missingKey",
  (lngs: readonly string[], namespace: string, key: string, res: string) => {
    console.warn("🔑 Missing key:", {
      languages: lngs,
      namespace,
      key,
      fallbackValue: res,
    });
  }
);

export default i18next;
